<template>

</template>

<script>
export default {
  data(){
    return{
      imgLogo:""
    }
  },
  created(){
    let timer =  setInterval(() => {
      if(this.$Logo.length > 0){
        clearInterval(timer)
        this.imgLogo = this.$Logo
      }
    } , 1000)
  }
};
</script>

<style lang="less">
.header {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  position: relative;
  left: 0;
  background-color: rgb(3,28,59);
  .line_wamp{
    width: 35%;
    height: 100%;
    padding: .625rem;
    box-sizing: border-box;
  }
  .title{
    padding: 1.875rem;
  }
  .logn{
    position: absolute;
  }
  .line{
    position: absolute;
    bottom: 0;
  }
}
</style>